export enum EAuditType {
  exchangeRate = 'AUDIT.TYPE.EXCHANGERATE',
  riskControl = 'AUDIT.TYPE.RISKCONTROL',
  store = 'AUDIT.TYPE.STORE',
  transRefund = 'AUDIT.TYPE.TRANSREFUND',
  operation = 'AUDIT.TYPE.OPERATION',
}

export interface IAuditProcessReq {
  jobs: string[]
  reason: string
}
